import { Container } from '@mui/material';
import getPageMetaTags from '../../../lib/meta/_getMetaTags';
import StockList from '../../../src/components/Browse/StockList';
import { getStocksJSONData } from '../../../src/utils/helpers';

export default function BrowseStocks({ themeMode, stocks_data, sortedSections }) {
  return (
    <Container maxWidth="xl">
      <StockList stockData={stocks_data} sortedSections={sortedSections} />
    </Container>
  );
}

export async function getServerSideProps({ params }) {
  const baseUrl = process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000'
    : process.env.NEXT_PUBLIC_URL;

  try {
    const filtered_stocks_data = await getStocksJSONData({
      url: `${baseUrl}/api/get-stock-data`,
      alphabet: params?.alphabet,
    }) || [];

    let groupedAndSorted = filtered_stocks_data.reduce((acc, item) => {
      let key;
      if (item && item.n1) {
        const firstChar = item.n1.charAt(0).toUpperCase();
        key = isNaN(firstChar) ? firstChar : '#';
      } else {
        key = '#';
      }
      acc[key] = acc[key] || [];
      acc[key].push(item);
      return acc;
    }, {});

    for (const key in groupedAndSorted) {
      if (groupedAndSorted.hasOwnProperty(key)) {
        groupedAndSorted[key].sort((a, b) => a.n1.localeCompare(b.n1));
      }
    }

    const sortedSections = Object.keys(groupedAndSorted).sort((a, b) => {
      if (a === '#') return -1;
      if (b === '#') return 1;
      return a.localeCompare(b);
    });

    const meta_tags = (await getPageMetaTags('/blogs', false)) || {};
    const { getMetaTags } = meta_tags || {};

    return {
      props: {
        meta_tags: getMetaTags?.tags || null,
        stocks_data: groupedAndSorted,
        sortedSections,
      },
    };
  } catch (error) {
    console.error('Error fetching stock data:', error);
    return {
      notFound: true,
    };
  }
}

// import { Container, } from '@mui/material';
// import { dataConstants } from '../../../src/constants';
// import getPageMetaTags from '../../../lib/meta/_getMetaTags';
// import StockList from '../../../src/components/Browse/StockList';
// import { getStocksJSONData } from '../../../src/utils/helpers';

// export default function BrowseStocks({ themeMode, stocks_data, sortedSections }) {

//   return (
//     <>
//       <Container maxWidth="xl">
//         <StockList stockData={stocks_data} sortedSections={sortedSections} />
//       </Container>
//     </>
//   )
// }

// export async function getStaticPaths() {
//   const alphabets = Array.from({ length: 26 }, (_, index) => String.fromCharCode(65 + index));
//   const paths = alphabets.map(a => ({ params: { alphabet: a.toLowerCase() } }))

//   return {
//     paths,
//     fallback: 'blocking'
//   }
// }

// export async function getStaticProps({ params, type = "stock", limit = 15 }) {
//   const baseUrl = process.env.NODE_ENV === 'development'
//     ? 'http://localhost:3000'
//     : process.env.NEXT_PUBLIC_URL;
//   let groupedAndSorted;
//   // const stocks_data = require('../../../public/assets/search/stock.json');
//   // const filtered_stocks_data = stocks_data.filter((stock) => stock?.t?.toLowerCase().startsWith(params?.alphabet.toLowerCase()) || stock?.n1?.toLowerCase().startsWith(params?.alphabet.toLowerCase()));
//   //stock.t.startsWith(params?.alphabet)

//   const filtered_stocks_data = await getStocksJSONData({
//     url: `${baseUrl}/api/get-stock-data`,
//     alphabet: params?.alphabet,
//   }) || [];

//   try {
//     groupedAndSorted = filtered_stocks_data && filtered_stocks_data.length > 0 ? filtered_stocks_data?.reduce((acc, item) => {
//       let key;

//       if (item && item.n1) {
//         const firstChar = item.n1.charAt(0).toUpperCase();
//         key = isNaN(firstChar) ? firstChar : '#'; // Check if it's a number
//       } else {
//         key = '#'; // Default to '#' if n1 is undefined or null
//       }

//       acc[key] = acc[key] || [];
//       acc[key].push(item);
//       return acc;
//     }, {}) : null;

//     for (const key in groupedAndSorted) {
//       if (groupedAndSorted.hasOwnProperty(key)) {
//         if (key === '#') {
//           groupedAndSorted[key].sort((a, b) => a.n1.localeCompare(b.n1));
//         } else {
//           groupedAndSorted[key].sort((a, b) => a.n1.localeCompare(b.n1));
//         }
//       }
//     }
//   } catch (error) {
//     console.error('Error during grouping and sorting:', error);
//   }

//   if (!groupedAndSorted) {
//     console.error('Grouped and sorted data is undefined.');
//   }

//   const sortedSections = Object.keys(groupedAndSorted).sort((a, b) => {
//     if (a === '#') return -1; // '#' section should come first
//     if (b === '#') return 1;
//     return a.localeCompare(b); // Sort other sections alphabetically
//   });

//   const meta_tags = (await getPageMetaTags('/blogs', false)) || {}
//   const { getMetaTags } = meta_tags || {}

//   return {
//     props: {
//       meta_tags: getMetaTags?.tags || null,
//       stocks_data: groupedAndSorted,
//       sortedSections
//     },
//     revalidate: dataConstants.REVALIDATE_IN.SEVEN_DAYS,
//     // notFound: process.env.NODE_ENV !== 'production' ? false : true,
//   }
// }
